import React from "react";
import * as AvatarPrimitive from "@radix-ui/react-avatar";

import { cn } from "./utils/cn";

const AvatarRoot = ({
  className,
  ...props
}: React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Root>) => (
  <AvatarPrimitive.Root
    className={cn(
      "relative flex shrink-0 overflow-hidden rounded-full",
      className
    )}
    {...props}
  />
);

const AvatarImage = ({
  className,
  ...props
}: React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Image>) => (
  <AvatarPrimitive.Image
    className={cn("aspect-square object-cover h-full w-full", className)}
    {...props}
  />
);

const AvatarFallback = ({
  className,
  ...props
}: React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Fallback>) => (
  <AvatarPrimitive.Fallback
    className={cn(
      "flex h-full w-full items-center justify-center rounded-full bg-gray-200",
      className
    )}
    {...props}
  />
);

interface AvatarProps extends AvatarPrimitive.AvatarImageProps {
  fallback?: string;
  size?: number;
}

export function Avatar({
  size = 0,
  fallback,
  className,
  style,
  ...props
}: AvatarProps) {
  return (
    <AvatarRoot
      className={className}
      style={{ ...style, width: size, height: size }}
    >
      {props.src && <AvatarImage {...props} />}
      {fallback && (
        <AvatarFallback style={{ fontSize: size * 0.375 }}>
          {fallback}
        </AvatarFallback>
      )}
    </AvatarRoot>
  );
}
